import React from "react";

import "./home.css";

function Home() {
  return (
    <>
      <div className="content">
        <div className="hero-1">
          <h3> Culture of India </h3>
          <p>
            {" "}
            The culture of India refers collectively to the thousands of
            distinct and unique cultures of all religions and communities
            present in India. India's languages, religions, dance, music,
            architecture, food and customs differ from place to place within the
            country. Indian culture, often labeled as an amalgamation of several
            cultures, spans across the Indian subcontinent and has been
            influenced by a history that is several millennia old. Many elements
            of India's diverse cultures, such as Indian religions, philosophy,
            cuisine, languages, dance, music and movies have a profound impact
            across the Indosphere, Greater India and the world.
            <img src="https://hcdevilsadvocate.com/wp-content/uploads/2018/05/Symbolic-Colors-of-India-867x900.jpg" />
          </p>

          <p>
            {" "}
            India's diversity has inspired many writers to pen their perceptions
            of the country's culture. These writings paint a complex and often
            conflicting picture of the culture of India. India is one of the
            most ethnically and religiously diverse countries in the world. The
            concept of "Indian culture" is a very complex and complicated
            matter. Indian citizens are divided into various ethnic, religious,
            caste, linguistic and regional groups, making the realities of
            "Indianness" extremely complicated. This is why the conception of
            Indian identity poses certain difficulties and presupposes a series
            of assumptions about what concisely the expression "Indian" means.
            However, despite this vast and heterogeneous composition, the
            creation of some sort of typical or shared Indian culture results
            from some inherent internal forces (such as a robust Constitution,
            universal adult franchise, flexible federal structure, secular
            educational policy, etc.) and from certain historical events (such
            as Indian Independence Movement, Partition, wars against Pakistan,
            etc.)
          </p>
        </div>

        <div className="hero-2">
            <h3> Traditions & Customs </h3>
            <p>In India, the saying 'Atithi Devo Bhavah' is also integral. It means 'the guest is equivalent to god'. It is a Sanskrit verse taken from the Hindu scriptures, which later became a part of the 'Code of conduct for Hindu society since the guest has always been of supreme importance in the Culture of India. Hospitality means relationship between a host and guest , where the host always receives the guest with full honor. Our heritage is famous for its hospitality . we treat our guest as God enters our home we give full respect to them and offer best services in terms of food and lodging. Our old saying is very famous in this context "Atithi Devo Bhava"
                </p>
                <img src="http://atithidevobhava.in/wp-content/uploads/2015/04/Atithi-Devo-Bhava-Logo.png" />
            </div>
      </div>
    </>
  );
}

export default Home;
